import { intl } from '@/intl'

export const getAddNewTWExceptionText = () =>
  intl.translate({ id: 'components.timeWindowExceptionList.addNew' })
